<template>
    <div>
<!-- 高德地图组件 -->
<!-- 1.最开始使用vue百度地图插件，上线发现点聚合超过3K会卡死整个页面 -->
<!-- 2.准备使用原生百度地图，发现原生百度地图官网点聚合只要超过5000左右就会卡死，放弃 -->
<!-- 3.查看vue高德地图,vue高德地图插件(github反应)点聚合5K会造成卡顿，放弃 -->
<!-- 4.使用高德地图原生地图，引入的js文件在public文件夹下的index.html里-->
<!-- 如果对高德地图原生api不是非常熟悉请不要乱动造成不必要的BUG -->
<!-- 目前经过测试，5W点内会有小卡顿，10W点左右会有明显卡顿,现在默认请求数据每次请求一页，每页10W个点 -->
      <div class="map" id="container">
      </div>
      <p class="MapTime">{{$t('lang.particulars.ProcessDate')}}:{{UpdateTime}}</p>
    </div>
</template>

<script>
//添加全局变量
// 地图实例
let mapObj=null
// 设备点
let marker=null
// 设备点集合
let markers=[]
// 点聚合
let cluster=null
// 信息窗体
let infoWindow=null
import { getDeviceAddressList } from '@/api/login'
import { mapGetters } from 'vuex'
export default {
  props:{
    allDevice:{
      type:Number
    }
  },
  data(){
    return{
      offset:1,
      //默认加载10W台设备，如果超过这个数量页面会造成卡顿
      limit:100000,
      //定时刷新地图
      MapTime:null,
      //更新时间
      UpdateTime:null
    }
  },
  mounted(){
    //创建地图实例
    mapObj=new AMap.Map('container', {//'map-location'是对应页面盒子的id
        resizeEnable: true,
        center: [105, 34],
        zoom: 4,
        zooms:[3,20],
        expandZoomRange:true,
        viewMode:'3D',
        lang:this.$i18n.locale==='zh-CN'?'zh_cn':'en'
    })
    //创建信息窗体实例
    infoWindow = new AMap.InfoWindow({offset: new AMap.Pixel(0, -10)});
    //获取点
    this.NewMarker()
    //定时器，60秒更新一次点
    this.MapTime=setInterval(()=>{
      this.NewMarker()
    },60000)
  },
  methods:{
    // 信息窗体内容函数，获取到选中的设备点信息，显示信息窗体
 markeronmouseover(e){
     infoWindow.setContent(
         `<p style="margin: 10px 0px 0px 0px;">${this.$t('lang.dashboard.Serials')}：${e.target.B.deviceSn}</p>
          <p>${this.$t('lang.dashboard.name')}：${e.target.B.deviceName}</p>
        <p>${this.$t('lang.dashboard.ADDRESS')}：${e.target.B.deviceAddress}</p>`
     );
     infoWindow.open(mapObj, e.target.getPosition());
 },
//  移出点隐藏信息窗体
 markeronmouseout(){
   infoWindow.close()
 },
//  跳转当前点击信息窗体设备的设备详情
 routerpush(e) {
    this.$router.push({
    name: 'Particulars',
    params: {id: e.target.Ge.deviceId}
  })
 },
 //创建点与点聚合事件
 NewMarker(){
   //新增allDevice，默认全部设备,离线设备，1：在线设备，2：所有设备
  getDeviceAddressList(this.offset,this.limit,this.allDevice)
    .then((res)=>{
      //当前更新时间
      let date=new Date()
      this.UpdateTime=date.toLocaleString(this.$i18n.locale=='zh-CN'?'zh':'en')
      //60秒获取一次新的数据，如果点聚合已经存在了删除所有点与点数组
        if(cluster!==null){
          cluster.clearMarkers()
          markers=[]
        }
        res.data.data.list.forEach(element => {
            marker=new AMap.Marker({
            position: [element.deviceLongitude,element.deviceLatitude],
            content: `
            <p style="color: red;font-size: 16px;font-weight: bold;">${element.deviceName!=undefined?element.deviceName:''}</p>
            <img src="https://webapi.amap.com/theme/v1.3/markers/n/mark_bs.png" class="markericon"  />
            `,
            offset: new AMap.Pixel(-48, -60),
            deviceId:element.deviceId,
            deviceSn:element.deviceSn,
            deviceName:element.deviceName!=undefined?element.deviceName:'',
            deviceAddress:element.deviceAddress
        })
        //创建点信息窗体内容
        marker.content=`<p style="margin: 10px 0px 0px 0px;">${this.$t('lang.dashboard.Serials')}：${element.deviceSn}</p>
          <p>${this.$t('lang.dashboard.name')}：${element.deviceName}</p>
        <p>${this.$t('lang.dashboard.ADDRESS')}：${element.deviceAddress}</p>`
        //动态添加移入移出事件
        marker.on('mouseover', this.markeronmouseover)
        marker.on('mouseout',this.markeronmouseout)
        marker.on('click',this.routerpush)
        //添加到海量点聚合
        markers.push(marker)
        });
        //实例化点聚合
        mapObj.plugin(["AMap.MarkerClusterer"],()=> {
        cluster = new AMap.MarkerClusterer(
        mapObj,     // 地图实例
        markers,    // 海量点组成的数组
        )
        })
    })
 },
  //修改地图语言
  setLang(Lang){
    mapObj.setLang(Lang)
  }
},
beforeDestroy(){
  // 进入其它页面时销毁地图
  mapObj=null
  marker=null
  markers=[]
  cluster=null
  infoWindow=null
  //页面销毁前删除定时器
  clearInterval(this.MapTime);
},
watch:{
  // 在线离线全部设备下拉框切换时重新加载地图
  allDevice:{
    handler(NewValue,OldValue){
      this.NewMarker()
    }
  }
}
}
</script>

<style scoped>
.map {
    width: 100%;
    margin: 0.2rem auto 0 auto;
    display: inline-block;
    height: 88vh;
}

.mapcon {
    width: 100%;
    height: 10rem;
    border-radius:2%;
}

.con {
    margin-left: 0%;
    width: 100%;
    text-align: center;
}

.svglist {
    margin: 0.5rem;
}

.seekinput {
    width: 2rem;
    height: 0.3rem;
    margin: 0.2rem;
}
.concenx{
    position: absolute !important;
    left: 25% !important;
}
.MapMarkerName{
  color: red;
  font-size: 20px;
  font-weight: bold;
}
.MapTime{
  position: fixed;
  top: 20vh;
  left: 40%;
  font-size: 20px;
  color: red;
  font-weight: bold;
}
</style>
